import type { ActiveSessionState } from '../services/api/coachActiveSession';

/**
 * Cumulative seconds the coach has spent on a given authored section.
 *
 * `section_time_seconds` holds the server-accumulated total per section (keyed
 * by section index as a string). For the CURRENT section we add the live delta
 * since `current_section_entered_at`, so the number ticks up in real time; for
 * any other section it's just the accumulated total.
 *
 * Extracted from CoachActiveSessionPage (MED-1223) so the pacing hook and the
 * live page share one definition of "time on section".
 */
export function computeSectionElapsedSeconds(
  state: ActiveSessionState,
  sectionIndex: number,
  nowMs: number
): number {
  const accumulated = state.section_time_seconds[String(sectionIndex)] ?? 0;
  if (
    state.current_section_index === sectionIndex &&
    state.current_section_entered_at !== null
  ) {
    const live = Math.floor(
      (nowMs - new Date(state.current_section_entered_at).getTime()) / 1000
    );
    return accumulated + Math.max(0, live);
  }
  return accumulated;
}
